import React from 'react';
import { Card } from './components/Card/Card';

import { Container } from './Cards.styles';
import { drawerInfoProps } from '../../../../Evaluations';
import { useCards } from './Cards.hooks';
import { convertToRoman } from 'helpers/convertToRoman';
import { Header } from './components/Header/Header';

interface CardsProps {
	onChangeDrawerInfo: (e: drawerInfoProps) => void;
	campaignId: string;
	selectedBranchOfficeId: string;
	variant: 'total' | 'detail';
}

export const Cards = ({
	campaignId,
	onChangeDrawerInfo,
	selectedBranchOfficeId,
	variant,
}: CardsProps): JSX.Element => {
	const { isLoading, dataGuideCampaigns } = useCards({
		campaignId,
		selectedBranchOfficeId,
	});

	if (isLoading) {
		return (
			<Container variant={variant}>
				<Header />
				<Card variant={variant} url="1" loading={true} requiredPercentage={0} />
				<Card variant={variant} url="2" loading={true} requiredPercentage={0} />
			</Container>
		);
	}

	return (
		<div>
			<Header />
			<Container variant={variant}>
				{dataGuideCampaigns.map((guideCampaign: any) => (
					<Card
						variant={variant}
						key={guideCampaign.id}
						url={guideCampaign.url}
						title={guideCampaign.name}
						subtitle={`Guía de referencia ${convertToRoman(
							guideCampaign.sequence + 1,
						)}`}
						description={guideCampaign.description}
						porcent={guideCampaign.percent}
						requiredPercentage={guideCampaign.requiredPercentage}
						onChangeDrawerInfo={onChangeDrawerInfo}
					/>
				))}
			</Container>
		</div>
	);
};
